import React from 'react';

type DateTimeTextProps =
{
    value?: string | null
    emptyText?: string
    className?: string
}

const hasExplicitTimeZone = (value: string): boolean => /([zZ]|[+-]\d{2}:\d{2})$/.test(value.trim());

function formatDateTime(value: string): string
{
    const date = new Date(value);

    if (Number.isNaN(date.getTime()))
        return value;

    return date.toLocaleString();
}

function DateTimeText({ value, emptyText = '—', className = '' }: DateTimeTextProps)
{
    if (!value)
        return <span className={className}>{emptyText}</span>;

    const rawValue = value.trim();
    const hasExplicit = hasExplicitTimeZone(rawValue);
    const classes = hasExplicit ? [className] : ['text-danger', 'whitespace-nowrap', className];
    const title = hasExplicit ? rawValue : 'Wartość pochodzi z nieznanej strefy czasowej';
    const text = hasExplicit ? formatDateTime(rawValue) : rawValue;
    const warning = hasExplicit ? '' : '⚠️';

    return <span className={classes.filter(Boolean).join(' ')} title={title}>{text} {warning}</span>;
}

export default DateTimeText;